import { useMemo, type CSSProperties } from "react";
import { useTheme } from "@repo/tokens";

const MODAL_SHADOW = "0px 1px 50px rgba(0, 0, 0, 0.32)";

export function useRegisterToUnlockOverlayStyles(isMobile: boolean) {
  const { theme } = useTheme();
  const radius = theme.radii["2xl"];

  return useMemo(
    () => ({
      modal: {
        modal: {
          borderTopLeftRadius: radius,
          borderTopRightRadius: radius,
          borderBottomLeftRadius: isMobile ? 0 : radius,
          borderBottomRightRadius: isMobile ? 0 : radius,
          boxShadow: isMobile ? theme.shadows.none : MODAL_SHADOW,
        },
        body: {
          flex: "0 0 auto",
          overflow: "visible",
        },
      } satisfies Record<string, CSSProperties>,

      content: {
        alignItems: "center",
        gap: "2rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        paddingTop: "2.5rem",
        paddingBottom: "2.5rem",
        textAlign: "center",
      } satisfies CSSProperties,

      title: {
        ...theme.typography.headline.small.regular,
        fontWeight: 500,
        color: theme.colors.text[10],
        textAlign: "center",
      } satisfies CSSProperties,

      description: {
        ...theme.typography.title.medium.emphasized,
        color: theme.colors.neutral[20],
        textAlign: "center",
        fontWeight: 500,
      } satisfies CSSProperties,
    }),
    [isMobile, radius, theme],
  );
}
